export type ValueSignalRect = {
    left: number
    top: number
    right: number
    bottom: number
}

export type ValueSignalViewport = {
    left: number
    top: number
    width: number
    height: number
}

export type ValueSignalSafeArea = {
    top: number
    right: number
    bottom: number
    left: number
}

type ValueSignalPopoverPositionInput = {
    anchor: ValueSignalRect
    popover: { width: number; height: number }
    viewport: ValueSignalViewport
    safeArea?: ValueSignalSafeArea
    bottomObstructionTop?: number
    margin?: number
    anchorGap?: number
}

const clamp = (value: number, min: number, max: number) => {
    if (max <= min) return min
    return Math.min(Math.max(value, min), max)
}

export const calculateValueSignalPopoverPosition = ({
    anchor,
    popover,
    viewport,
    safeArea = { top: 0, right: 0, bottom: 0, left: 0 },
    bottomObstructionTop,
    margin = 12,
    anchorGap = 5,
}: ValueSignalPopoverPositionInput) => {
    const viewportRight = viewport.left + viewport.width
    const viewportBottom = viewport.top + viewport.height
    const safeLeft = viewport.left + safeArea.left + margin
    const safeRight = viewportRight - safeArea.right - margin
    const safeTop = viewport.top + safeArea.top + margin
    let safeBottom = viewportBottom - safeArea.bottom - margin

    if (Number.isFinite(bottomObstructionTop)) {
        safeBottom = Math.min(safeBottom, Number(bottomObstructionTop) - anchorGap)
    }

    const maxWidth = Math.max(0, safeRight - safeLeft)
    const maxHeight = Math.max(0, safeBottom - safeTop)
    const width = Math.min(popover.width, maxWidth)
    const height = Math.min(popover.height, maxHeight)
    const left = clamp(anchor.left, safeLeft, safeRight - width)
    const below = anchor.bottom + anchorGap
    const above = anchor.top - anchorGap - height
    const preferredTop = below + height <= safeBottom ? below : above
    const top = clamp(preferredTop, safeTop, safeBottom - height)

    return { left, top, maxWidth, maxHeight }
}
